import { app } from '../../utils/store';

export default class Landing {
    constructor() {
        this.section = {
            visual: document.querySelectorAll('section.visual'),
        };

        this.html = document.querySelector('html');
    }

    init() {
        this.set();
    }

    set = () =>{
        // Visual Section
        if(Sniff.browser.name == 'safari' && this.section.visual[0]){
            this.section.visual.forEach((section) =>{
                var button = section.querySelector('.btn-file span');
                button.innerHTML = button.getAttribute('data-label-start');
            })
        }
    }
}